const UrlServices = {
    fetchAllCategories: "category/all/user-category",
    rdDeviceDetail: "settings/rd-device-details",
    modelServices: "service/model",
    getTimes: "times/get-times",
    storeInfo: "settings/store-info",
    submitRequest: "lead/save",
    allStores: "settings/get-all-stores",
};

export default UrlServices;